import React, { useState } from "react";
import useFilter from "../Hooks/useFilters";
import "../styles/filters.css";
import PriceRangeSlider from "./PriceSlider";

const Filter = ({ setFilters, availableFilters,selectedFilters,setSelectedFilters }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 35990]);
  const { getFilters, loading, error } = useFilter();

  const applyFilter = (attribute, value) => {
    setSelectedFilters((prev) => {
      const currentValues = prev[attribute] || [];
      const updatedValues = currentValues.includes(value)
        ? currentValues.filter((v) => v !== value)
        : [...currentValues, value];

      const updatedFilters = { ...prev, [attribute]: updatedValues };
      setFilters(updatedFilters);
      return updatedFilters;
    });
    closeSidebar(); // Close sidebar when a filter is applied
  };

  const removeFilter = (attribute, value) => {
    setSelectedFilters((prev) => {
      const updatedValues = (prev[attribute] || []).filter((v) => v !== value);
      const updatedFilters = { ...prev, [attribute]: updatedValues };
      if (updatedValues.length === 0) delete updatedFilters[attribute];
      setFilters(updatedFilters);
      return updatedFilters;
    });
  };
  const clearAllFilters = () =>{
    setSelectedFilters({})
    setFilters({})
  }
  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  const handlePriceChange = (values) => {
    const priceFilter = {
      start_price: values[0],
      end_price: values[1],
    };
    setPriceRange(values);
    setSelectedFilters((prev) => ({ ...prev, ...priceFilter }));
    setFilters((prev) => ({ ...prev, ...priceFilter }));
  };

  return (
    <>
      <div className="flex">
        <div
          className="flex items-center cursor-pointer me-3"
          onClick={toggleSidebar}
        >
          <i className="fa-solid fa-filter me-2"></i>
          <p>Filter</p>
        </div>

        {/* Display Selected Filters */}
        <div className="selected-filters flex flex-wrap mt-2">
      {Object.entries(selectedFilters).map(
        ([attribute, values]) =>
          attribute !== "start_price" &&
          attribute !== "end_price" &&
          values.map((value) => {
            // Remove color code if present (assuming it's a hex code)
            const displayValue = value.replace(/#[0-9A-Fa-f]{6}/g, "").trim();

            return (
              <div
                key={`${attribute}-${value}`}
                className="filter-chip flex items-center p-1 rounded mr-2 mb-2"
              >
                <button
                  className="mr-2 text-black transition-transform duration-300 ease-in-out relative w-3 h-3"
                  onClick={() => removeFilter(attribute, value)}
                >
                  <span className="absolute inset-0 transform rotate-45 bg-current w-full h-[2px] top-1/2 left-0 -translate-y-1/2 transition-transform duration-300 ease-in-out" />
                  <span className="absolute inset-0 transform -rotate-45 bg-current w-full h-[2px] top-1/2 left-0 -translate-y-1/2 transition-transform duration-300 ease-in-out" />
                </button>
                <span className="text-sm">
                  {attribute}: {displayValue}
                </span>
              </div>
            );
          })
      )}
      
      {/* "Clear All" button */}
      {Object.entries(selectedFilters).length > 0  && <button
        className="clear-all-btn mb-3 flex items-center px-2 py-1 rounded-xl text-sm font-medium bg-black text-white hover:bg-gray-800 transition duration-300 ml-2 mt-2"
        onClick={clearAllFilters}
      >
        <span className="mr-1 relative w-3 h-3 mb-0">
          <span className="absolute inset-0 transform rotate-45 bg-current w-full h-[2px] top-1/2 left-0 -translate-y-1/2" />
          <span className="absolute inset-0 transform -rotate-45 bg-current w-full h-[2px] top-1/2 left-0 -translate-y-1/2" />
        </span>
        Clear All
      </button>}
    </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 z-50"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}          onClick={closeSidebar}
        >
          <div
            className={`fixed left-0 top-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
              isOpen ? "translate-x-0" : "-translate-x-full"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center bg-black p-4">
              <p className="text-base font-medium text-white text-center w-full">
                FILTER
              </p>
              <button className="text-right text-white" onClick={toggleSidebar}>
                <i className="fa-solid fa-times text-base"></i>
              </button>
            </div>

            <div className="overflow-y-auto h-full p-4">
              <PriceRangeSlider
                minPrice={0}
                maxPrice={35990}
                onPriceChange={handlePriceChange}
                closeSidebar={closeSidebar}
                filters={selectedFilters}
              />

              {availableFilters.length > 0 && (
                <>
                  {availableFilters
                    .filter((attribute) => attribute.name === "Color")
                    .map((attribute) => (
                      <div key={attribute.name} className="mb-6 last:mb-16">
                        <h3 className="text-sm font-medium mb-5 relative underlineFilter">
                          {attribute.name}
                        </h3>
                        <div className="mt-2 max-h-44 overflow-y-auto border-t border-b py-3">
                          {Object.entries(attribute.values).map(
                            ([value, count]) => {
                              const [colorName, colorCode] = value.split(":");
                              const isSelected =
                                selectedFilters["Color"]?.includes(value);
                              return (
                                <div
                                  key={value}
                                  onClick={() => applyFilter("Color", value)}
                                  className="flex items-center mb-3 cursor-pointer"
                                >
                                  <span
                                    className={`w-8 h-8 rounded-full flex items-center justify-center mr-2`}
                                    style={{
                                      backgroundColor: colorCode,
                                    }}
                                  >
                                    {isSelected && (
                                      <i className="fa fa-check text-white text-xm"></i>
                                    )}
                                  </span>
                                  <span className="text-xs">
                                    {colorName} ({count})
                                  </span>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    ))}
                  {availableFilters
                    .filter((attribute) => attribute.name !== "Color")
                    .map((attribute) => (
                      <div key={attribute.name} className="mb-6 last:mb-16">
                        <h3 className="text-sm font-medium mb-5 relative underlineFilter">
                          {attribute.name}
                        </h3>

                        <div className="mt-2 max-h-32 overflow-y-auto border-t border-b py-2">
                          {
                            // Render other filters as checkboxes
                            Object.entries(attribute.values).map(
                              ([value, count]) => (
                                <div
                                  key={value}
                                  className="flex items-center mb-2"
                                >
                                  <input
                                    type="checkbox"
                                    id={`${attribute.name}-${value}`}
                                    checked={selectedFilters[
                                      attribute.name
                                    ]?.includes(value)}
                                    onChange={() =>
                                      applyFilter(attribute.name, value)
                                    }
                                    className="mr-2"
                                  />
                                  <label
                                    htmlFor={`${attribute.name}-${value}`}
                                    className="flex-1 text-xs"
                                  >
                                    {value} ({count})
                                  </label>
                                </div>
                              )
                            )
                          }
                        </div>
                      </div>
                    ))}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Filter;
